import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import api from '../utils/api';
import logoSymbol from '../assets/logo-symbol.png';

const VerifyEmail: React.FC = () => {
  const { token } = useParams<{ token: string }>();
  const [status, setStatus] = useState<'verifying' | 'success' | 'error'>('verifying');
  const [message, setMessage] = useState('');
  const navigate = useNavigate();
  const requested = useRef(false);

  useEffect(() => {
    if (!token || requested.current) return;
    requested.current = true;
    api
      .get(`/api/auth/verify-email/${token}`)
      .then((res: any) => {
        setStatus('success');
        setMessage(res.data?.message || 'Email verified successfully!');
      })
      .catch((err) => {
        setStatus('error');
        setMessage(
          err.response?.data?.error ||
            err.response?.data?.message ||
            'Verification failed. The link may have expired.'
        );
      });
  }, [token]);

  return (
    <div className="min-h-screen bg-[#0f0f10] flex items-center justify-center p-4 relative overflow-hidden">
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute -top-40 -right-40 w-80 h-80 bg-[#22d3ee]/10 rounded-full blur-3xl"></div>
        <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-[#38bdf8]/10 rounded-full blur-3xl"></div>
      </div>

      <div className="relative z-10 glass-card p-8 w-full max-w-md text-center animate-fade-in">
        <img src={logoSymbol} alt="BlockBoard" className="h-16 mx-auto mb-6" />

        {!token || status === 'error' ? (
          <>
            <h1 className="text-2xl font-bold text-white mb-3">Verification failed</h1>
            <p className="text-red-400 mb-6">{message || 'Invalid verification link.'}</p>
            <button onClick={() => navigate('/login')} className="btn-primary w-full">
              Go to Sign In
            </button>
          </>
        ) : status === 'verifying' ? (
          <>
            <h1 className="text-2xl font-bold text-white mb-3">Verifying your email…</h1>
            <p className="text-white/60">Hang tight, this only takes a second.</p>
          </>
        ) : (
          <>
            <h1 className="text-2xl font-bold text-white mb-3">Email verified ✓</h1>
            <p className="text-white/60 mb-6">{message}</p>
            <button onClick={() => navigate('/login')} className="btn-primary w-full">
              Sign In
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default VerifyEmail;
